import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AdministracaoFgiComponent } from './administracao-fgi.component';


const routes: Routes = [
  {
    path: 'admin/usuarios',
    component: AdministracaoFgiComponent,
    canActivate: [AuthenticationGuard],
    data: { canReuse: false }
  },
  {
    path: 'admin/agentes-financeiros',
    component: AdministracaoFgiComponent,
    canActivate: [AuthenticationGuard],
    data: { canReuse: false }
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministracaoRoutingModule { }
